// extracted by mini-css-extract-plugin
var _1 = "Tabs-module__active--KXTB5";
var _2 = "Tabs-module__animateUploadProgressBarWidth--wLkQX";
var _3 = "Tabs-module__animatedBackground--PyWog";
var _4 = "Tabs-module__container--LzMPv";
var _5 = "Tabs-module__disabledShadow--Bjr6t";
var _6 = "Tabs-module__left--VAZrw";
var _7 = "Tabs-module__right--_4YXI";
var _8 = "Tabs-module__scrollCaret--g7kvx";
var _9 = "Tabs-module__scrollContainer--LyUj2";
var _a = "Tabs-module__scrollHint--DRVpL";
var _b = "Tabs-module__tab--Os_sY";
var _c = "Tabs-module__tabs--sDVY5";
var _d = "Tabs-module__withRight--Po74T";
export { _1 as "active", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "container", _5 as "disabledShadow", _6 as "left", _7 as "right", _8 as "scrollCaret", _9 as "scrollContainer", _a as "scrollHint", _b as "tab", _c as "tabs", _d as "withRight" }
